/** @format */

import React, {useEffect, useState} from 'react';
import {FormGeneralHelper} from '../../helpers/FormGeneral';
import InputAdornment from '@material-ui/core/InputAdornment';
import Error from '@material-ui/icons/ErrorOutline';
import CustomInput from '../../components/CustomInput/CustomInputExt';
import adescomStyle from '../../assets/jss/adescom/adescomStyle';
import {makeStyles, Popper} from '@material-ui/core';
import I18n from '../../components/Translate/I18n';
import COLORS from '../../assets/themes/OPL/colors';

type InputFormProps = {
    callback: (
        event: React.FormEvent<HTMLInputElement>,
        stateName: string,
        typeField: string,
        typeCallback: string,
        required: boolean,
        vMax: number,
        vMin?: number
    ) => void;
    stateName: string;
    status: string;
    disabled?: boolean;
    typeCallback: string;
    typeField: string;
    displayFieldName: string;
    required: boolean;
    autoComplete: string;
    vMax: number;
    vMin?: number;
    value: any;
    [key: string]: any;
};

const useStyles = makeStyles(adescomStyle);

const inputFormErrorPopperStyle = {
    backgroundColor: COLORS.MAIN.DARK,
    color: COLORS.MAIN.LIGHT,
    padding: 10,
};

const InputForm = (props: InputFormProps): React.ReactElement => {
    const classes = useStyles();
    const {
        callback,
        disabled,
        status,
        stateName,
        typeCallback,
        typeField,
        displayFieldName,
        vMax,
        vMin,
        required,
        autoComplete,
        ...rest
    } = props;

    const [inputErrors, setInputErrors] = useState<Array<string>>([]);
    const [displayErrorsModal, setDisplayErrorsModal] = useState<React.ReactElement | null>(null);

    const onMouseEnterHandler = (event: any): void => {
        setDisplayErrorsModal(
            <Popper style={inputFormErrorPopperStyle} open={true} anchorEl={event.currentTarget}>
                {inputErrors.map((el, index) => {
                    return (
                        <div key={index}>
                            <I18n trans={el}/>
                        </div>
                    );
                })}
            </Popper>
        );
    };

    const onMouseLeaveHandler = (): void => {
        setDisplayErrorsModal(null);
    };

    useEffect(() => {
        if (inputErrors.length === 0 && displayErrorsModal) {
            setDisplayErrorsModal(null);
        }
    }, [inputErrors, displayErrorsModal])

    return (
        <>
            <CustomInput
                {...rest}
                success={status === FormGeneralHelper.SUCCESS}
                error={status === FormGeneralHelper.ERROR}
                labelText={displayFieldName}
                id={stateName}
                formControlProps={{
                    fullWidth: true,
                }}
                required={required}
                autoComplete={autoComplete}
                inputProps={{
                    onChange: (event: React.FormEvent<HTMLInputElement>): void => {
                        // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
                        // @ts-ignore
                        setInputErrors(FormGeneralHelper.verifyInputFields(typeField, event.target.value, vMin, vMax, required));
                        return callback(event, stateName, typeField, typeCallback, required, vMax, vMin);
                    },
                    type: typeField,
                    disabled: disabled || false,
                    endAdornment:
                        status === FormGeneralHelper.ERROR ? (
                            <InputAdornment position="end">
                                <Error style={{
                                    cursor: 'default'
                                }}
                                       className={classes.danger} onMouseEnter={onMouseEnterHandler}
                                       onMouseLeave={onMouseLeaveHandler}/>
                            </InputAdornment>
                        ) : (
                            undefined
                        ),
                }}
            />
            {displayErrorsModal}
        </>
    );
};

export default InputForm;
